var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-row',{attrs:{"no-gutters":""}},[_c('v-card-title',{staticClass:"pa-0 mb-3 ml-2"},[(_vm.icon)?_c('v-icon',{staticClass:"mr-3"},[_vm._v(_vm._s(_vm.icon))]):_vm._e(),_vm._v(" "+_vm._s(_vm.text)+" ")],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }